import StyledMenu from "./StyledMenu"

export default StyledMenu